module.exports = __webpack_public_path__ + "static/media/deliveryOrder.054600df.png";